import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { deleteCheckSet, copyCheckSet } from '../../redux/checkSetSlice';
import { serverReason } from '../patientTabs/prescriptionHelpers';

// Delete (asked first) and copy, shared by the doctor's tab and the hospital
// page so both say the same thing.
export default function useSetActions() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    const remove = async (set) => {
        const answer = await Swal.fire({
            title: t('checkSets.delete_title'),
            text: t('checkSets.delete_text', { name: set.name }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('checkSets.delete_confirm'),
            cancelButtonText: t('checkSets.cancel'),
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#6b7280',
        });
        if (!answer?.isConfirmed) return false;
        const res = await dispatch(deleteCheckSet({ setId: set.setId }));
        if (deleteCheckSet.fulfilled.match(res)) {
            toast.success(t('checkSets.deleted'));
            return true;
        }
        toast.error(serverReason(res.payload, t('checkSets.delete_failed'), i18n.language));
        return false;
    };

    // `doctorId`: the hospital admin copying into THAT doctor's sets (the
    // server requires it from the admin); a doctor copies into their own.
    const copy = async (set, { doctorId } = {}) => {
        const res = await dispatch(copyCheckSet({ setId: set.setId, doctorId }));
        if (copyCheckSet.fulfilled.match(res)) {
            toast.success(doctorId ? t('checkSets.copied_to_doctor') : t('checkSets.copied'));
            return res.payload?.set || null;
        }
        toast.error(serverReason(res.payload, t('checkSets.copy_failed'), i18n.language));
        return null;
    };

    return { remove, copy };
}
